import styled from 'styled-components';

export const NavbarContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0rem 2rem;
  padding-top:0rem !important;
  // background-color: #222;
  position: relative;
  flex-direction: row;
  align-items: center;
  background-color: #f3f2f2;
  background: linear-gradient(#777, transparent);
  justify-content: space-evenly;
  position: relative;
  z-index: 1000;
  @media (max-width: 768px) {

    justify-content: space-between;

  }

`;

export const Logo = styled.img`
  height: 48px;
  width: 48px;
`;

export const MenuContainer = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MenuItem = styled.div`
  color: #fff;
  &:hover {
    color: #ffc500;
    cursor:pointer;
  }
  @media (max-width: 768px) {

    :hover {
      color:black;
      cursor:pointer;
    }      }
  // a {
  //   color: inherit;
  //   text-decoration: none;
  //   &:hover {
  //     color: #ffc500;
  //     cursor:pointer;
  //   }
  }

  ${({ isResponsive }) =>
    isResponsive &&
    `
    margin-bottom: 1rem;
  `}
`;

export const HamburgerButton = styled.div`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 24px;
  height: 16px;
  cursor: pointer;

  div {
    width: 100%;
    height: 2px;
    background-color: #fff;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ResponsiveMenuContainer = styled.div`
  display: none;
  flex-direction: column;

  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #ffc464;
  padding: 1rem;
  padding-top:0rem !important;
  z-index: -1;
div{
  padding:10px;
  // text-align:center;
}
  @media (max-width: 768px) {
    display: flex;
  }
`;
export const LogoContainer = styled.div`
  width: 25%;
  :hover {
    cursor: pointer;
  }
`;

export const IconsContainer = styled.div`
  background-color: #000000;
  opacity: 36%;
  border: 1px solid black;
  border-radius: 30px;
  width: 86px;
  height: 30px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;
`;

export const WrapperPopover = styled.div`
  max-width: 1150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;


export const ContentMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 248px auto;
  height: auto;
`;

export const ContentInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  text-align: center;
  color: #404040;
  :hover {
    background-color: #ffc500;
    border-radius: 4px;
  }
  width: 154px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin: unset;
  padding: 5px;
  align-items: center;
  :hover {
    background: #ffc500 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 0.29;
  }

`;

export const TitleContent = styled.p`
  text-align: center !important;
  font-size:calc(0.4em + 0.5vw) !important;
  @media (max-width: 786px) {
    font-size:calc(0.5em + 0.7vw) !important;
  }

  color: #404040;
  :hover {
    cursor: pointer;
  }
  padding: 5px;
  /* margin: auto; */
  margin: unset;
`;